module.exports = __webpack_public_path__ + "img/837001342_4.69b1a336.jpeg";